export default "__VITE_ASSET__cfd6dcdb__"